<app-referrals-client-listing
  [loading]="loadingReferralMatchOptions"
  [referralMatchOptions]="referralMatchOptions"
  (referralVerificationChange)="onReferralVerificationChange($event)" />
